/** 오디오 기능 슬라이스 — 블록 직렬화. (삽입은 업로드/파일패널/붙여넣기 경로, 자체 슬래시 없음) */
import { audioBlockToElement, audioElementToBlock } from "./audio.js";

export default {
  name: "audio",
  blocks: { audio: { toElement: audioBlockToElement, fromElement: audioElementToBlock } },
};
